module.exports = __webpack_public_path__ + "img/box2.3f4481a3.png";